// ✅ Trekkin.app — TrekkinPanelStyles.js v3.2.0
// 🔹 Painéis sobrepostos ao mapa, alinhados à barra inferior
// 🔹 Remove fundo branco, mantém margens laterais e scroll interno

export const trekkinBubbleStyle = {
  background: "rgba(255, 255, 255, 0.55)",
  backdropFilter: "blur(12px) saturate(160%)",
  WebkitBackdropFilter: "blur(12px) saturate(160%)",
  border: "none",
  borderRadius: "18px",
  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
  width: 52,
  height: 52,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  cursor: "pointer",
  transition: "all 0.25s ease",
};

export const trekkinBubbleIcon = {
  width: 26,
  height: 26,
  opacity: 0.9,
};